module.exports = __webpack_public_path__ + "media/site_bg.de4cf465.mp4";